// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2G7EY","fileBtn":"File_fileBtn__V54rE","closeBtn":"File_closeBtn__1igNE","fileSelected":"File_fileSelected__13jyZ","disabled":"File_disabled__3zEVt"};